module.exports = __webpack_public_path__ + "img/TerrieChan.a69471f4.png";